export const cancerMatcherRegexp = /cancer|lymphoma|leukemia|myeloma|tumor/i
